var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19995 34.7326L13.3369 30.02C16.597 34.2847 20.0601 36.2512 23.9161 36.2512C27.7512 36.2512 31.1165 34.308 34.2297 30.0763L40.4535 34.6751C35.9625 40.7766 30.3798 43.9999 23.9161 43.9999C17.4732 43.9999 11.8367 40.7986 7.19995 34.7326Z",
    fill: "url(#paint0_linear_1057_3562)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.57 14.2512L12.6482 23.6861L7.59912 17.8159L23.5933 4L39.4613 17.8269L34.389 23.6763L23.57 14.2512Z",
    fill: "url(#paint1_linear_1057_3562)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1057_3562",
    x1: 7.19995,
    y1: 39.5284,
    x2: 40.4535,
    y2: 39.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8930FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49CCF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1057_3562",
    x1: 7.59912,
    y1: 17.3876,
    x2: 39.4613,
    y2: 17.3876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF02F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickUpIcon);
export default __webpack_public_path__ + "static/media/clickUp-icon.c8ea59ba4f5ed87025852f2b792a3082.svg";
export { ForwardRef as ReactComponent };